/* Homepage slot clone of the real Oil PDP ao-convergence frame engine.
 * Original 90 frames, directional loader and semantic pacing retained.
 * Only namespace, slot ownership and square-source selection differ. */
(function () {
  'use strict';
  if (window.AoHomeSlotFormula) { window.AoHomeSlotFormula.scan(); return; }
  var instances = new Set();
  function init(host) {
    if (instances.has(host)) return;
    instances.add(host);
    var destroyed = false, rafId = 0;
    var ac = typeof AbortController === 'function' ? new AbortController() : null;
    var cleanup = function (event) {
      if (!event.target.contains(host)) return;
      destroyed = true;
      if (rafId) cancelAnimationFrame(rafId);
      if (ac) ac.abort();
      if (io) io.disconnect();
      if (state) { state.started = false; state.frames = []; }
      instances.delete(host);
      delete host.__aoHomeFormula;
      document.removeEventListener('shopify:section:unload', cleanup);
    };
    document.addEventListener('shopify:section:unload', cleanup);
    var wrap = host;
    var stage = host;
    var canvas = host.querySelector('[data-home-slot-formula-canvas]');
    var poster = host.querySelector('[data-home-slot-formula-poster]');
    if (!wrap || !stage || !canvas) return;
    var COUNT = parseInt(wrap.getAttribute('data-home-slot-formula-count'), 10) || 90;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setPhase(phase) {
      ['data-home-slot-formula-beat', 'data-home-slot-formula-dot'].forEach(function (attr) {
        host.querySelectorAll('[' + attr + ']').forEach(function (el) {
          el.classList.toggle('is-on', parseInt(el.getAttribute(attr), 10) === phase);
        });
      });
    }
    if (reduce || wrap.getAttribute('data-home-slot-formula-motion') === 'false') { setPhase(3); return; }

    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    // The approved 8:7 slot uses the existing square sequence at both viewport sizes.
    // The wide PDP sequence belongs to a panoramic stage, not this media frame.
    var mq = { matches: true };
    var LADDER = 8;          // coarse anchor stride (lowest priority)
    var KEEP = 26;           // sliding retention window (frames each side)
    var AHEAD = 18, BEHIND = 6, MAXQ = 5;

    var state = null;        // active sequence state
    function makeState() {
      var mobile = mq.matches;
      poster.src = poster.getAttribute(mobile ? 'data-src-m' : 'data-src-d');
      return {
        gen: (state ? state.gen + 1 : 1),
        base: wrap.getAttribute(mobile ? 'data-home-slot-formula-base-m' : 'data-home-slot-formula-base-d'),
        frames: new Array(COUNT), loading: new Array(COUNT), failures: new Array(COUNT).fill(0),
        inflight: 0, started: false, lastDrawn: -1, cur: 0, dir: 1
      };
    }
    state = makeState();
    host.__aoHomeFormula = function () { return { cur: state.cur, drawn: state.lastDrawn, dir: state.dir, failed: state.failures.map(function (n, i) { return n >= 2 ? i : -1; }).filter(function (i) { return i >= 0; }) }; };

    function release(s, keepIdx) {
      for (var i = 0; i < COUNT; i++) {
        if (s.frames[i] && Math.abs(i - keepIdx) > KEEP && i % LADDER !== 0 && i !== COUNT - 1) {
          s.frames[i] = null;
        }
      }
    }
    function load(s, i) {
      if (destroyed) return;
      if (i < 0 || i >= COUNT || s.frames[i] || s.loading[i] || s.failures[i] >= 2 || s.inflight >= MAXQ) return;
      s.loading[i] = true;
      s.inflight++;
      var img = new Image();
      img.decoding = 'async';
      img.onload = img.onerror = function (e) {
        if (destroyed) return;
        s.inflight--;
        s.loading[i] = false;
        if (s.gen !== state.gen) return;          // breakpoint switched: discard
        if (e.type === 'load') {
          s.frames[i] = img;
          draw();                                  // draw() re-reads the CURRENT
        } else { s.failures[i]++; }                 // bounded retry; keep poster/nearest frame on failure
        pump();                                    // never paint an obsolete one
      };
      img.src = s.base + ('00' + i).slice(-3) + '.webp';
    }
    function pump() {
      if (destroyed) return;
      var s = state;
      if (!s.started) return;
      // 1) the exact target frame outranks everything
      load(s, s.cur);
      // 2) the directional window, nearest first, in the current direction
      var ahead = s.dir >= 0 ? AHEAD : BEHIND;
      var behind = s.dir >= 0 ? BEHIND : AHEAD;
      var step = s.dir >= 0 ? 1 : -1;
      for (var k = 1; k <= ahead; k++) load(s, s.cur + step * k);
      for (var k2 = 1; k2 <= behind; k2++) load(s, s.cur - step * k2);
      // 3) coarse anchors only take whatever download slots are left
      for (var i = 0; i < COUNT; i += LADDER) load(s, i);
      load(s, COUNT - 1);
      release(s, s.cur);
    }
    function sizeCanvas() {
      var w = stage.clientWidth, h = stage.clientHeight;
      if (!w || !h) return false;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var bw = Math.round(w * dpr), bh = Math.round(h * dpr);
      if (canvas.width !== bw || canvas.height !== bh) { canvas.width = bw; canvas.height = bh; state.lastDrawn = -1; }
      return true;
    }
    function draw() {
      if (destroyed) return;
      var s = state;
      var target = s.cur, pick = -1;
      // DIRECTIONAL pick: never show a frame the scroll direction hasn't
      // reached yet, so no visible correction ever steps against it.
      if (s.dir >= 0) {
        for (var d = 0; d <= KEEP; d++) { if (s.frames[target - d]) { pick = target - d; break; } }
      } else {
        for (var d2 = 0; d2 <= KEEP; d2++) { if (s.frames[target + d2]) { pick = target + d2; break; } }
      }
      if (pick < 0 || !sizeCanvas() || pick === s.lastDrawn) return;
      var img = s.frames[pick];
      var cw = canvas.width, ch = canvas.height;
      var sc = Math.max(cw / img.naturalWidth, ch / img.naturalHeight);
      var dw = img.naturalWidth * sc, dh = img.naturalHeight * sc;
      ctx.drawImage(img, (cw - dw) / 2, (ch - dh) / 2, dw, dh);
      s.lastDrawn = pick;
      if (canvas.style.opacity !== '1') canvas.style.opacity = '1';
    }

    function clamp01(v) { return Math.max(0, Math.min(1, v)); }
    // SEMANTIC PACING MAP (progress -> frame). The natural-flow progress is
    // untouched; only the frame chosen for a given progress changes, so the
    // opening pour (frames 000-030) receives 60% of the natural passage,
    // the settle (031-049) 15%, and the pipette draw (050-089) 25%.
    // Piecewise-continuous: 0.60 -> 30|31 and 0.75 -> 49|50 are 1-frame steps.
    function mapFormulaFrame(progress) {
      var frame;
      if (progress <= 0.60) {
        frame = Math.round((progress / 0.60) * 30);
      } else if (progress <= 0.75) {
        frame = 31 + Math.round(((progress - 0.60) / 0.15) * 18);
      } else {
        frame = 50 + Math.round(((progress - 0.75) / 0.25) * 39);
      }
      return Math.max(0, Math.min(COUNT - 1, frame));
    }
    var currentPhase = 1;
    function update() {
      if (destroyed) return;
      // One layout read; scroll position only selects frame + copy phase.
      var rect = stage.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var p = clamp01((vh * 0.8 - rect.top) / (rect.height + vh * 0.22));
      var idx = mapFormulaFrame(p);
      if (idx > state.cur) state.dir = 1;
      else if (idx < state.cur) state.dir = -1;
      state.cur = idx;
      // Same window as the IntersectionObserver rootMargin below; also works inside the Theme Editor's cross-origin iframe, where rootMargin is ignored.
      if (!state.started && rect.top < vh * 2.5 && rect.bottom > -vh * 1.5) state.started = true;
      draw();
      pump();
      // Copy phase follows the MAPPED frame, not raw progress, so the beats
      // stay synchronized with what is actually on screen.
      var phase = idx <= 24 ? 1 : idx < 50 ? 2 : 3;
      if (phase !== currentPhase) { currentPhase = phase; setPhase(phase); }
    }
    // Passive listeners; at most ONE scheduled rAF; nothing runs on a timer.
    var ticking = false;
    function schedule() {
      if (destroyed || ticking) return;
      ticking = true;
      rafId = requestAnimationFrame(function () { rafId = 0; ticking = false; update(); });
    }
    window.addEventListener('scroll', schedule, { passive: true, signal: ac ? ac.signal : undefined });
    window.addEventListener('resize', schedule, { passive: true, signal: ac ? ac.signal : undefined });

    // Preload before the section approaches; never trap scrolling meanwhile.
    function start() {
      if (destroyed || state.started) return;
      state.started = true;
      pump();
      update();
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { start(); io.disconnect(); } });
      }, { rootMargin: '150% 0px 150% 0px' });
      io.observe(wrap);
    } else {
      start();
    }

    // Breakpoint switch: cancel the old set entirely, start the new one.
    var onMQ = function () {
      var wasStarted = state.started;
      state = makeState();
      canvas.style.opacity = '0';
      if (wasStarted) { state.started = true; pump(); }
      schedule();
    };
    if (mq.addEventListener) mq.addEventListener('change', onMQ);
    else if (mq.addListener) mq.addListener(onMQ);
    // No eager update(). It read the stage's geometry at DOMContentLoaded for a chapter well below the
    // fold, forcing a synchronous layout of the whole document; with content-visibility on the sections
    // below the hero, measuring one also forces the browser to lay it out. The IntersectionObserver that
    // drives this sequence already calls update() when the chapter comes within range.

  }
  function scan() { document.querySelectorAll('[data-home-slot-formula]').forEach(init); }
  window.AoHomeSlotFormula = { scan: scan };
  document.addEventListener('shopify:section:load', scan);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
})();
